function injectStyle (ssrContext) {
  require("!!../../../../../ly_report/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../ly_report/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-43bf853e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../ly_report/node_modules/vue-loader/lib/selector?type=styles&index=0!./statistic.vue")
}
var normalizeComponent = require("!../../../../../ly_report/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../ly_report/node_modules/vue-loader/lib/selector?type=script&index=0!./statistic.vue"
import __vue_script__ from "!!babel-loader!../../../../../ly_report/node_modules/vue-loader/lib/selector?type=script&index=0!./statistic.vue"
/* template */
import __vue_template__ from "!!../../../../../ly_report/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-43bf853e\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../ly_report/node_modules/vue-loader/lib/selector?type=template&index=0!./statistic.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/g2-chart/src/statistic.vue
// module id = null
// module chunks = 